import $ from 'jquery';
import Player from '@vimeo/player';

$('iframe[src*="vimeo.com"]').each(function () {
  const $this = $(this);
  $this.css({
    '--video-width': $this.attr('width'),
    '--video-height': $this.attr('height'),
  });

  const player = new Player(this);

  player.on('loaded', () => $this.addClass('is-loaded'));
  player.on('play', () => $this.addClass('is-playing'));
});
